import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DwTaskItem } from '../../../z-devware/tasks/models/dw-task-item.model';

@Component({
  selector: 'app-dashboard-task-list',
  templateUrl: './dashboard-task-list.component.html',
  styleUrls: ['./dashboard-task-list.component.scss']
})
export class DashboardTaskListComponent {
  @Input() tasks: DwTaskItem[] = [];

  constructor(private router: Router) { }

  openTask(task: DwTaskItem): void {
    if (task.clickFunc) {
      task.clickFunc();
      return;
    }

    if (task.navigateUrl) {
      this.router.navigateByUrl(task.navigateUrl);
    }
  }
}
